<script>

import { Line } from 'vue-chartjs'
export default {
  extends: Line,
  props: {
    pubDate: {
      type: Array
    },
    height: {
      type: Number, default: 350
    },
    blurry: {
      type: Boolean, default: false
    }
  },
  name: 'DocumentByDate',
  watch: {
    pubDate: function (val, oldVal) {
      if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
        this.init()
      }
    }
  },
  data () {
    return {
      blurDisplay: false,
      labels: [],
      data: [],
      chart: null,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        elements: { point: { radius: 0 } },
        tooltips: {
          enabled: false
        },
        scales: {
          yAxes: [{
            ticks: {
              display: false
            },
            scaleLabel: {
              display: true,
              labelString: 'documents'
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'years'
            }
          }]
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  methods: {
    init: function () {
      let years = Object.assign([], this.pubDate)
      years.sort((year1, year2) => {
        return year1.name - year2.name
      })

      this.labels = []
      this.data = []
      let currentYear = new Date().getFullYear()

      if (years.length !== 0) {
        let nbItemToAdd = years.length < 3 ? 3 - years.length : 0
        while (nbItemToAdd > 0) {
          years.forEach((year) => {
            years.unshift({name: (years[0].name - 1), nb: 0, nb_doc: 0})
          })
          --nbItemToAdd
        }
      }

      if (years.length > 2) {
        years.forEach((year, index) => {
          if (year.name < (currentYear + 2)) {
            this.labels.push(year.name)
            let nb

            if (typeof years[index - 1] === 'undefined') {
              nb = (typeof year.nb_doc !== 'undefined') ? (1 / 2 * (year.nb_doc + years[index + 1].nb_doc)) : (1 / 2 * (year.nb + years[index + 1].nb))
            } else if (typeof years[index + 2] === 'undefined') {
              nb = (typeof year.nb_doc !== 'undefined') ? (1 / 2 * (years[index - 1].nb_doc + year.nb_doc)) : (1 / 2 * (years[index - 1].nb + year.nb))
            } else {
              nb = (typeof year.nb_doc !== 'undefined') ? (1 / 3 * (years[index - 1].nb_doc + year.nb_doc + years[index + 1].nb_doc)) : (1 / 3 * (years[index - 1].nb + year.nb + years[index + 1].nb))
            }
            this.data.push(nb)
          }
        })
      }
    },
    resize: function () {
      document.getElementById('line-chart').style.height = this.height + 'px'
    },
    draw: function () {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            label: 'Data One',
            borderColor: 'rgba(248, 212, 122, 0.5)',
            backgroundColor: 'rgba(248, 212, 122, 0.5)',
            data: this.data,
            fill: true
          }
        ]
      }, this.options)
      this.resize()

      if ($('#noDataPudDate').length !== 0) {
        $('#noDataPudDate').remove()
      }

      if (this.blurry === true && this.blurDisplay === false) {
        document.getElementById('line-chart').style.filter = 'blur(8px)'

        let blurDiv = document.createElement('div')
        blurDiv.textContent = 'Data not visible for free account'
        blurDiv.style.position = 'absolute'
        blurDiv.style.top = '150px'
        blurDiv.style.width = '100%'
        blurDiv.className = 'text-center'

        this.$el.append(blurDiv)
        this.blurDisplay = true
      } else if (this.data.length === 0) {
        let div = document.createElement('div')

        div.textContent = 'no data'
        div.style.position = 'absolute'
        div.style.top = '150px'
        div.style.width = '100%'
        div.className = 'text-center'
        div.id = 'noDataPudDate'
        this.$el.append(div)
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/DocumentByDate.vue